export const styles = {
  popupTitle: {
    // margin: "10px 20px 20px",
  },
  parentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  modalContainer: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: "12px",
  },
  choice: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    width: "100%",
    margin: 0,
    padding: "16px",
    borderRadius: "16px",
    border: "1px solid #EAE8F2",
    backgroundColor: "#F4F3F8",
    color: "#1B1340",
    font: "inherit",
    textAlign: "left" as const,
    cursor: "pointer",
    "&:hover": { backgroundColor: "#F7F5FF", borderColor: "#DDD8EE" },
    "&:focus-visible": {
      outline: "2px solid #6C3CE9",
      outlineOffset: 2,
    },
  },
  choiceIcon: {
    width: 36,
    height: 36,
    borderRadius: "12px",
    display: "grid",
    placeItems: "center",
    color: "#6C3CE9",
    backgroundColor: "#fff",
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  choiceTitle: {
    fontWeight: 700,
    fontSize: 15,
    lineHeight: "22px",
    letterSpacing: "-0.02em",
    color: "#1B1340",
  },
  choiceText: {
    fontWeight: 500,
    fontSize: 13,
    lineHeight: "18px",
    color: "#5C5870",
  },
  createOrderBtn: {
    display: "flex",
    alignItems: "center",
    margin: "10px 20px 20px",
    justifyContent: "flex-end",
  },
  addOrderTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#111827",
    textAlign: "center",
    margin: 0,
  },
  HeadBtns:{
    // border:"1px solid black",
    padding:"auto 50px",
    height: "35px",
    width:"150px",
    textAlign:"center",
    fontFamily:"Roboto"
  }
};
